"use client";

export function SessionLimitBanner() {
  return (
    <div className="w-full max-w-4xl mx-auto px-4 mb-3">
      <div className="flex items-center justify-between rounded-xl bg-gradient-to-r from-indigo-500/10 to-pink-500/10 border border-indigo-500/20 px-4 py-2.5">
        <p className="text-sm text-foreground">
          You&apos;ve reached the session limit.{" "}
          <a href="/pricing" className="font-semibold text-indigo-400 hover:text-indigo-300 underline underline-offset-2 transition-colors">
            Upgrade to Pro
          </a>{" "}
          to unlock unlimited sessions.
        </p>
      </div>
    </div>
  );
}
